import { msalInstance } from '.';

export const getApiBearerToken = async (app_scope_id) => {
  const apiAuth = {
    scopes: [app_scope_id],
    account: msalInstance.getAllAccounts()?.[0],
  };
  if (msalInstance.getAllAccounts()?.length > 0) {
    return await msalInstance.acquireTokenSilent(apiAuth);
  }
};

export const getWorkSpaceApiBearerToken = async (app_scope_id) => {
  const apiAuth = {
    scopes: [app_scope_id],
    account: msalInstance.getAllAccounts()?.[0],
  };
  if (msalInstance.getAllAccounts()?.length > 0) {
    return await msalInstance.acquireTokenSilent(apiAuth);
  }
};
